<div class="grid-x">
  <div class="cell small-12 margin-bottom">
    <dropdown-select-button (click)="addWidget()" (selectedValue)="selectedWidgetType = $event">
      Add New Widget
      @for (item of availableWidgets; track item) {
        <dropdown-select-item [value]="item">{{item}}</dropdown-select-item>
      }
    </dropdown-select-button>
  </div>
  @for (widget of config.widgets; track widget; let isLast = $last) {
    <div class="cell small-12">
      <widget-item [item]="widget"></widget-item>
      @if (!isLast) {
        <div class="horizontal-rule"></div>
      }
    </div>
  }
</div>